<template>
    <div class="main">
        <div class="photos">
            <div class="photo" v-for="(file, index) in files" :key="index">
                <img :src="getImgUrl(file)" />
                <div class="preview">
                    <i v-if="isVideo(file)" class="action el-icon-video-play" @click="viewMedia(index)"></i>
                    <i v-else class="action el-icon-view" @click="viewMedia(index)"></i>
                    <i v-if="!showAdd" class="el-icon-close action" @click="removeFile(index)"></i>
                </div>
                <div class="triangle"></div>
                <div class="remark">{{ isVideo(file) ? 'mov' : 'pic' }}</div>
            </div>
            <div v-if="showAdd" class="el-upload el-upload--picture-card" @click="openPicker">
                <i class="el-icon-check"></i>
            </div>
            <media-preview ref="mediaPreview"></media-preview>
            <media-picker @input="onSelected" ref="mediaPicker" :maxNumber="maxNumber" v-model="pickValue"></media-picker>
            <!-- <p>images:{{ images }}</p>
            <p>videos:{{ videos }}</p> -->
        </div>
    </div>
</template>

<script>

import MediaPreview from '@/components/MediaPreview/index.vue'

export default {
    name: 'MediaChoose',
    components: { MediaPreview },
    props: {
        value: { type: String},
        images: { type: Array, required: true },
        videos: { type: Array, required: true },
        maxNumber: { type: Number, default: 999 },
        showAdd:{type:Boolean,default:true},
    },
    watch: {
        value: {
          immediate: true, // 初始化时也同步一次
            handler(nv,ov) {
              // if(nv.indexOf("3_20250919111420A002.jpg"))
              console.log("监听value：",nv);
                this.pickValue=nv;
            }
        }
    },
    computed: {
        files() {
          console.log("计算:", this.pickValue);
            if (this.$utils.isValid(this.pickValue)) return this.pickValue.split(",");
            return [];
        },
    },
    data() {
        return {
            baseUrl: process.env.VUE_APP_BASE_API,
            index: 0,
            pickValue:null,
        }
    },
    methods: {
        onSelected(val){
          this.$emit('input', val); // 👈 必须 emit，才能驱动 v-model & 父组件@input
        },
        openPicker() {
            this.$refs.mediaPicker.open(this.images, this.videos);
        },
        viewMedia(index) {
            let files = this.files.map(el => this.baseUrl + el);
            this.$refs.mediaPreview.open(files, index)
        },
        isVideo(file) {
            if (file.indexOf(".mp4") > -1) return true;
            return false;
        },
        getImgUrl(file) {
            if (file.indexOf(".mp4") > -1) return this.baseUrl + file.replace(".mp4", ".jpg");
            return this.baseUrl + file;
        },
        //移除文件
        removeFile(index) {
            this.files.splice(index, 1);
            if(0==this.files.length){
              // this.pickValue=null;//服务端对null值是不传递(不处理的),要改为空就用空字符串''
              this.pickValue='';
            }else{
              this.pickValue=this.files.join(",");
            }
            this.$emit('input', this.pickValue);
        },
    }
}
</script>

<style scoped scss>
/*--以下设置上传文件列表预览----------------------------------------------------------------*/
.photos {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 10px;
}



.photo {
    position: relative;
    width: 150px;
    height: 150px;
    border: 1px solid #c0ccda;
    border-radius: 5px;
}

.triangle {
    position: absolute;
    top: 0;
    right: 0;
    width: 30px;
    height: 30px;
    border-top-right-radius: 5px;
    background: linear-gradient(45deg, transparent 50%, rgb(109, 189, 109) 50%);
}

.remark {
    position: absolute;
    z-index: 5;
    top: -8px;
    right: -2px;
    transform: rotate(45deg);
    color: white;
}

.preview {
    position: absolute;
    top: -1px;
    left: -1px;

    width: 150px;
    height: 150px;
    border-radius: 5px;

    font-size: 22px;
    color: white;
    background-color: black;
    opacity: 0;

    display: flex;
    justify-content: space-evenly;
    align-items: center;
}

.photo img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
    object-fit: contain;
    overflow: hidden;
}

.photo:hover .preview {
    opacity: 0.5;
}

.photo:hover .triangle {
    opacity: 0;
}

.photo:hover .remark {
    opacity: 0;
}

.el-icon-view {
    cursor: pointer;
}

.action {
    cursor: pointer;
}

.picker {
    display: flex;
    justify-content: center;
    align-items: center;

    font-size: 28px;
    color: #8c939d;
    border: 1px dashed #c0ccda;

    cursor: pointer;
}

.picker:hover {
    border-color: #1890ff;
    color: #1890ff;
}
</style>
